import { render, staticRenderFns } from "./SselectEditor.vue?vue&type=template&id=33811fa7&"
import script from "./SselectEditor.vue?vue&type=script&lang=js&"
export * from "./SselectEditor.vue?vue&type=script&lang=js&"
import style0 from "./SselectEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports